export enum DataType {
    STRING = "string",
    INT = "int",
    DATE = "date",
    TIME = "time",
    DATETIME = "datetime",
    BOOL = "bool",
    FLOAT = "float",
    CURRENCY = "currency",
    LIST = "list",
    OBJECT = "object",
    DATERANGE = 'daterange'
}
